module.exports = __webpack_public_path__ + "static/media/water3.86dda7b8.jpg";